export const exists = (thing: unknown) => thing !== undefined && thing !== null;
